import { SMALL } from '@dentalux/ui-library-core'
import { typography } from '@dentalux/ui-library-core/themes/typography/typography'
import { Theme } from '@mui/material/styles'

export const footerContainer = (theme: Theme) => ({
  backgroundColor: theme.palette.grey[100],
  borderTop: `1px solid ${theme.palette.grey[300]}`,
  height: 50,
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
})

export const leftCornerContent = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  ml: '16px',
}

export const clinicLogo = (theme: Theme) => ({
  width: 120,
  height: 32,
  [theme.breakpoints.down(SMALL)]: {
    width: 88,
    height: 24,
  },
})

export const rightCornerContent = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  mr: '16px',
}

export const p21LogoText = (theme: Theme) => ({
  ...typography['Lato Caption'],
  [theme.breakpoints.down(SMALL)]: {
    ...typography['Lato Caption Small'],
  },
})

export const p21Logo = (theme: Theme) => ({
  ml: '8px',
  width: 90,
  height: 16,
  [theme.breakpoints.down(SMALL)]: {
    width: 68,
    height: 12,
  },
})
